import type { Row } from '@tanstack/react-table'
import type { FC } from 'react'

import type { AssetTableEntryDTO } from '@/api/repository/repositorySchemas'
import { ExpanderCell } from '@/components/shared/AstaTable/AstaTable'
import { Badge } from '@/components/ui/badge'
import type { AssetWithParent } from '@/shared/types'

const GROUP_NAME_TO_LABEL: Record<string, string> = {
	'functional-rule': 'Functional',
	'performance-rule': 'Performance',
	'accessibility-rule': 'Accessibility',
	'resource-rule': 'Resource',
}

interface Props {
	row: Row<AssetTableEntryDTO>
	isGroupingActive: boolean
	rowOnClick: (asset: AssetWithParent) => void
}

export const NameCell: FC<Props> = ({ isGroupingActive, row, rowOnClick }) => {
	const { isGroup, asset, groupName } = row.original

	const gName =
		isGroup && Array.isArray(groupName)
			? groupName.length > 0
				? groupName.join(' - ')
				: 'Untagged'
			: typeof groupName === 'string' && groupName
				? groupName
				: 'Untagged'

	if (isGroup) {
		return (
			<ExpanderCell row={row} depth={0}>
				<div className="flex w-full items-center">
					<Badge variant="secondary">
						{GROUP_NAME_TO_LABEL[gName] || gName}
					</Badge>
					<span className="pl-4 text-sm text-muted-foreground">
						{row.original.subRows.length}
					</span>
				</div>
			</ExpanderCell>
		)
	}
	return (
		<div
			onClick={() => rowOnClick(row.original.asset)}
			className={`cursor-pointer text-foreground hover:underline ${
				isGroupingActive ? 'ml-7' : ''
			}`}
		>
			{asset.name}
		</div>
	)
}
